var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"arrow-right",class:_vm.isContactPanelActive ? 'fadeout-desktop': 'fadein-desktop'},[_c('img',{attrs:{"src":require("../assets/img/arrow-right.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }